import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SupplierCodeOfConduct from "@/pages/SupplierCodeOfConduct";

export const Route = createFileRoute("/en/supplier-code-of-conduct")({
  head: () => buildRouteHead("/en/supplier-code-of-conduct"),
  component: SupplierCodeOfConduct,
});

